class FeaturedCollection extends HTMLElement {
  constructor() {
    super();
    this.featuredContainer = this;
    this.navlinks = this.querySelectorAll('.collection__nav-link');
    this.viewAllLinks = this.querySelectorAll('.collection__view-all-link');
    this.sliderComponents = this.querySelectorAll('.slider-component'); // Handle multiple sliders

    // Initialize each slider component
    this.sliderComponents.forEach((sliderComponent) => {
      this.initSlider(sliderComponent);
    });

    // Initialize navigation links
    this.navlinks.forEach((link) => {
      link.addEventListener('click', this.activateTab.bind(this));
    });
  }

  initSlider(sliderComponent) {
    const slider = sliderComponent.querySelector('[id^="Slider-"]');
    const sliderItems = sliderComponent.querySelectorAll('[id^="Slide-"]');
    const prevButton = sliderComponent.querySelector('button[name="previous"]');
    const nextButton = sliderComponent.querySelector('button[name="next"]');
    const dotsContainer = sliderComponent.querySelector('.slider__dots');
    const currentPageElement = sliderComponent.querySelector('.slider-counter--current');
    const pageTotalElement = sliderComponent.querySelector('.slider-counter--total');

    let sliderItemOffset = 0;
    let slidesPerPage = 1;
    let totalPages = 1;
    let currentPage = 1;

    const initPages = () => {
      const sliderItemsToShow = Array.from(sliderItems).filter((element) => element.clientWidth > 0);
      if (sliderItemsToShow.length < 2) return;
      sliderItemOffset = sliderItemsToShow[1].offsetLeft - sliderItemsToShow[0].offsetLeft;
      slidesPerPage = Math.floor((slider.clientWidth - sliderItemsToShow[0].offsetLeft) / sliderItemOffset);
      totalPages = Math.ceil(sliderItemsToShow.length / slidesPerPage);
      update();
    };

    const update = () => {
      if (!slider || !nextButton) return;

      const previousPage = currentPage;
      currentPage = Math.round(slider.scrollLeft / sliderItemOffset) + 1;

      if (currentPageElement && pageTotalElement) {
        currentPageElement.textContent = currentPage;
        pageTotalElement.textContent = totalPages;
      }

      if (currentPage !== previousPage) {
        sliderComponent.dispatchEvent(
          new CustomEvent('slideChanged', {
            detail: {
              currentPage: currentPage,
              currentElement: sliderItems[currentPage - 1],
            },
          })
        );
      }

        // Disable "Previous" button if at the start
      if (slider.scrollLeft === 0) {
        prevButton.setAttribute('disabled', 'disabled');
      } else {
        prevButton.removeAttribute('disabled');
      }

      // Disable "Next" button if at the end
      const lastSlide = sliderItems[sliderItems.length - 1];
      if (isSlideVisible(lastSlide)) {
        nextButton.setAttribute('disabled', 'disabled');
      } else {
        nextButton.removeAttribute('disabled');
      }
      // if (isSlideVisible(sliderItems[0]) && slider.scrollLeft === 0) {
      //   prevButton.setAttribute('disabled', 'disabled');
      // } else {
      //   prevButton.removeAttribute('disabled');
      // }

      // if (isSlideVisible(sliderItems[sliderItems.length - 1])) {
      //   nextButton.setAttribute('disabled', 'disabled');
      // } else {
      //   nextButton.removeAttribute('disabled');
      // }
      updateDots();
    };

    const isSlideVisible = (element, offset = 0) => {
      const tolerance = 1; // Add a small tolerance for rounding issues
      const sliderRightEdge = slider.scrollLeft + slider.clientWidth - offset;
      const elementRightEdge = element.offsetLeft + element.clientWidth;
    
      return (
        element.offsetLeft >= slider.scrollLeft - tolerance &&
        elementRightEdge <= sliderRightEdge + tolerance
      );
    };
    // const isSlideVisible = (element, offset = 0) => {
    //   const lastVisibleSlide = slider.clientWidth + slider.scrollLeft - offset;
    //   return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= slider.scrollLeft;
    // };

    const onButtonClick = (event) => {
      event.preventDefault();
      const step = event.currentTarget.name === 'next' ? 1 : -1;

      const newScrollPosition = slider.scrollLeft + step * sliderItemOffset;
      const maxScrollPosition = (sliderItems.length - 1) * sliderItemOffset;
      setSlidePosition(Math.max(0, Math.min(newScrollPosition, maxScrollPosition)));
    };

    const setSlidePosition = (position) => {
      slider.scrollTo({
        left: position,
        behavior: 'smooth',
      });
    };

    const createDots = () => {
      dotsContainer.innerHTML = ''; // Clear existing dots
      for (let i = 0; i < sliderItems.length; i++) {
        const dot = document.createElement('div');
        dot.classList.add('dot');
        dot.dataset.index = i + 1;
        dot.addEventListener('click', () => scrollToPage(i + 1));
        dotsContainer.appendChild(dot);
      }
      dotsContainer.querySelector('.dot')?.classList.add('active');
    };

    const updateDots = () => {
      if (!dotsContainer) return;
      const dots = dotsContainer.querySelectorAll('.dot');
      dots.forEach((dot) => {
        dot.classList.toggle('active', parseInt(dot.dataset.index) === currentPage);
      });
    };

    const scrollToPage = (page) => {
      const position = (page - 1) * sliderItemOffset;
      setSlidePosition(position);
    };

    // Event listeners
    const resizeObserver = new ResizeObserver(() => {
      initPages();
      createDots();
      updateDots();
    });
    resizeObserver.observe(slider);

    slider.addEventListener('scroll', update);
    prevButton.addEventListener('click', onButtonClick);
    nextButton.addEventListener('click', onButtonClick);

    // Initialize slider
    initPages();
    createDots();
    updateDots();
  }

  activateTab(event) {
    if (event.target.classList.contains('is-active')) {
      return;
    }

    this.navlinks.forEach((link) => {
      link.classList.remove('is-active');
    });

    event.target.classList.add('is-active');
    this.activateCarousel(event.target.dataset.index);
    this.activateViewAll(event.target.dataset.index);
  }

  activateCarousel(activeIndex) {
    this.sliderComponents.forEach((item) => {
      if (item.dataset.index === activeIndex) {
        item.classList.add('is-active');
      } else {
        item.classList.remove('is-active');
      }
    });
  }

  activateViewAll(activeIndex) {
    if (this.viewAllLinks) {
      this.viewAllLinks.forEach((item) => {
        if (item.dataset.index === activeIndex) {
          item.classList.add('is-active');
        } else {
          item.classList.remove('is-active');
        }
      });
    }
  }
}

customElements.define('featured-collection', FeaturedCollection);